// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"8061f3d3","239":"a3a5a876","450":"90f580db","732":"a5db728d"}[chunkId] + ".chunk.js";
};